import { render } from "./BoxSection.vue?vue&type=template&id=178317d2&scoped=true&ts=true"
import script from "./BoxSection.vue?vue&type=script&lang=ts"
export * from "./BoxSection.vue?vue&type=script&lang=ts"

import "./BoxSection.vue?vue&type=style&index=0&id=178317d2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178317d2"]])

export default __exports__